import app from 'flarum/forum/app';
//import CoreHomeDiscussions from 'flarum/core/forum/components/HomeDiscussions';
import CoreHomeDiscussions from './HomeDiscussions_Latest';
import LinkButton from 'flarum/common/components/LinkButton';
import { slug } from '../../common';

// Make translation calls shorter
const t = app.translator.trans.bind(app.translator);
const prfx = `${slug}.forum.home.discussions`;

export default class HomeDiscussions_Last extends CoreHomeDiscussions {
	get limit() {
		return 5;
	}

	view() {
		const vnode = super.view();
		vnode.children.push(
			<LinkButton href={this.allLinkHref} className='LinkButton'>
				{this.allLinkText}
			</LinkButton>,
		);
		return vnode;
	}

	get allLinkText() {
		return t(`${prfx}.all_link`);
	}

	get allLinkHref() {
		return app.route('index');
	}
}
